function initGlytoneComplex(root) {
  if (!root || root.dataset.complexInitialized === 'true') return;

  root.dataset.complexInitialized = 'true';

  const modal = root.querySelector('[data-glytone-ingredients-modal]');
  const openButtons = root.querySelectorAll('[data-glytone-ingredients-open]');
  const closeButton = root.querySelector('[data-glytone-ingredients-close]');
  const backdrop = root.querySelector('.glytone-complex__modal-backdrop');

  if (!modal || !openButtons.length) return;

  let lastTrigger = null;

  const openModal = (trigger) => {
    lastTrigger = trigger;

    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('glytone-modal-open');

    closeButton?.focus();
  };

  const closeModal = () => {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('glytone-modal-open');

    lastTrigger?.focus();
  };

  openButtons.forEach((button) => {
    button.addEventListener('click', () => {
      openModal(button);
    });
  });

  closeButton?.addEventListener('click', closeModal);
  backdrop?.addEventListener('click', closeModal);

  document.addEventListener('keydown', (event) => {
    if (
      event.key === 'Escape' &&
      modal.classList.contains('is-open')
    ) {
      closeModal();
    }
  });
}

function initAllGlytoneComplex(scope = document) {
  scope
    .querySelectorAll('[data-glytone-complex]')
    .forEach(initGlytoneComplex);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    initAllGlytoneComplex();
  });
} else {
  initAllGlytoneComplex();
}

document.addEventListener('shopify:section:load', (event) => {
  initAllGlytoneComplex(event.target);
});